module.exports = __webpack_public_path__ + "static/media/KM.0ce33252.png";